export type TrackingCategory = "analytics" | "marketing";
export type TrackingConsent = Record<TrackingCategory, boolean>;

export const TRACKING_CONSENT_COOKIE = "aops_tracking_consent";
export const TRACKING_CONSENT_TTL_SECONDS = 395 * 24 * 60 * 60;
export const HONOR_GPC_AS_MARKETING_OPT_OUT = true;

export const DEFAULT_TRACKING_CONSENT: TrackingConsent = {
	analytics: true,
	marketing: true,
};

function decodeCookieValue(value: string): string {
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
}

/**
 * Missing, malformed, and unknown values remain allowed. This implements the
 * product's opt-out model: only an explicit `deny` disables a category.
 */
export function parseTrackingConsentCookie(
	value: string | undefined
): TrackingConsent {
	const consent = {...DEFAULT_TRACKING_CONSENT};
	if (!value) {
		return consent;
	}

	const params = new URLSearchParams(decodeCookieValue(value));
	if (params.get("v") !== "1") {
		return consent;
	}

	for (const category of ["analytics", "marketing"] as const) {
		if (params.get(category) === "deny") {
			consent[category] = false;
		}
	}

	return consent;
}

export function serializeTrackingConsent(consent: TrackingConsent): string {
	return [
		"v=1",
		`analytics=${consent.analytics ? "allow" : "deny"}`,
		`marketing=${consent.marketing ? "allow" : "deny"}`,
	].join("&");
}

export function applyGpc(
	consent: TrackingConsent,
	gpc: boolean
): TrackingConsent {
	if (!HONOR_GPC_AS_MARKETING_OPT_OUT || !gpc) {
		return consent;
	}
	return {...consent, marketing: false};
}
